import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';
import { useState } from 'react';

const TopVendorsSearchAmazon = () => {
    const [page, setPage] = useState(1);
    const [itemsPerPage] = useState(3); // Set default page size to 3
    
    const recentSearchedvendorsData = useSelector((state) => state.searchedProduct.searchedProduct);
    
    // Calculate total pages
    const totalPages = Math.ceil(recentSearchedvendorsData?.length / itemsPerPage);
    
    // Get current items
    const currentItems = recentSearchedvendorsData?.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    return (
        <section className="top-vendors py-80">
            <div className="container container-lg">
            {currentItems.length > 0 ? (
  <>
  

  <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Recent searched Vendor</h5>
                    </div>
                </div>
                <div className="row gy-4 vendor-card-wrapper">
                    {currentItems?.map((vendor) => (
                        <div className="col-xxl-3 col-lg-4 col-sm-6" key={vendor[0].id}>
                            <div className="vendor-card text-center px-16 pb-24">
                                <div className="">
                                    <img
                                        src={vendor[0].coverImageUrl}
                                        alt={vendor[0].shopName}
                                        className="vendor-card__logo m-12"
                                    />
                                    <h6 className="title mt-32">{vendor[0].shopName}</h6>
                                    <Link
                                        to={`/vendor/${vendor[0].userId}`}
                                        className="btn btn-main rounded-pill py-6 px-16 text-12 mt-8"
                                    >
                                        {vendor[0].shopName}
                                    </Link>
                                </div>
                                <div className="vendor-card__list mt-22 flex-center flex-wrap gap-8">
                                    {[...Array(5)].map((_, index) => (
                                        <div 
                                            className="vendor-card__item bg-white rounded-circle flex-center"
                                            key={index}
                                        >
                                            <img 
                                                src={vendor[0].imageLogoUrl}
                                                alt={`Product ${index + 1}`} 
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                
                {/* Pagination */}
                {recentSearchedvendorsData?.length > itemsPerPage && (
                    <div className="mt-32 flex-center">
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            size="large"
                        />
                    </div>
                )}
  </>
) : (
  <></>
)}

            </div>
        </section>
    )
}

export default TopVendorsSearchAmazon;